// extracted by mini-css-extract-plugin
export default {"container":"ToggleButtons_container__cs6KN","label":"ToggleButtons_label__L1gT3","toggles":"ToggleButtons_toggles__vIV4y"};